/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, MITSUB_S){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	let $path = location.pathname;

	// <IRトップ>メインスライド
	const topMainSlider = () => {
		$('.ir-idx-main-slider').slick({
			infinite: true,
			autoplay: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 2000,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			dots: false
		});
	};


	// ==============================================================================
	if($('.ir-idx-main-slider').length) {
		topMainSlider();
	}

})(window.jQuery, window.MITSUB_S);
